module.exports = __webpack_public_path__ + "img/nothing-here-yet.1589ecfe.png";